export const asset = {
  name_one: "actif",
  name_other: "actifs",
  add: {
    label: "Ajouter un actif",
  },
  geojson: {
    label: "Actifs linéaires",
  },
  technical: {
    label: "Techniques",
    lastUpdate: "Dernière mise à jour {{date}}",
    lastUpdateBy: "par {{user}}",
  },
  components: {
    label: "Composants",
  },
  interventions: {
    label: "Interventions",
  },
  observations: {
    label: "Observations",
  },
  timeline: {
    label: "Ligne de temps",
    goToIntervention: "Consulter l'intervention",
    modifiedBy: "Modifié par",
    filterByType: "Filtrer par type d'événement",
    filterBySubType: "Filtre par sous-type d'événement",
    extraItems: {
      manufactured: {
        title: "Fabriqué",
      },
      commissioned: {
        title: "Mise en service",
      },
      "theoretical-end-of-life": {
        title: "Fin de vie théorique",
      },
      today: {
        title: "Aujourd'hui",
      },
    },
  },
  delete: {
    label: "Supprimer l'actif",
  },
  form: {
    associateAssetWith: {
      asset: "Associer cet actif avec",
      component: "Associer ce composant avec",
    },
    informations: {
      asset: "Informations de l'actif",
      component: "Informations de le composant",
    },
    edit: {
      label: "Modifier l'actif",
      label_other: "Modifier les actifs",
      component: "Modifier le composant",
      component_other: "Modifier les composants",
    },
    add: {
      asset: "Ajouter un actif",
      component: "Ajouter un composant",
    },
    name: {
      label: "Nom",
    },
    assetType: {
      label: "Type d'actif",
      alert:
        'Les informations affichées dans l\'onglet "Techniques" seront supprimées en modifiant le type.',
    },
    referenceNumber: {
      label: "Numéro de référence",
      isOptionalMessage: "Si laissé vide, ce champ sera rempli automatiquement",
    },
    description: {
      label: "Description",
    },
    manufacturer: {
      label: "Manufacturier",
    },
    model: {
      label: "Modèle",
    },
    serialNumber: {
      label: "Numéro de série",
    },
    manufactureDate: {
      label: "Date de fabrication",
    },
    serviceDate: {
      label: "Date de mise en service",
    },
    assetInfo: {
      label: "Informations de l'actif",
    },
    technicalInfo: {
      label: "Informations techniques",
    },
    state: {
      label: "État",
    },
    assetPicture: {
      label: "Photo de l'actif",
    },

    location: {
      label: "Localisation",
    },
    organization: {
      label: "Organisation",
    },
    parent: {
      label: "Parent",
    },
    assetFiles: {
      label: "Fichiers joints",
    },
    severityGrid: {
      label: "Grille de sévérité",
    },
    conditionRating: {
      label: "Cote d'état",
    },
    cmmsId: {
      label: "Identifiant GMAO",
    },
    erpId: {
      label: "Identifiant ERP",
    },
    attendanceToken: {
      label: "Jeton de présence d'inspection",
      tokenProvided: "Jeton renseigné",
    },
    age: {
      label: "Âge de l’actif",
    },
    replacementCost: {
      label: "Coût de remplacement",
    },
    theoreticalLifespan: {
      label: "Durée de vie théorique",
      unit: "années",
      tooltip: "Durée de vie estimée de l'actif exprimée en années",
    },
    theoreticalRemainingLifespan: {
      label: "Durée de vie théorique restante",
    },
    studyFrequency: {
      label: "Fréquence d'étude",
      value: "{{nbrOfMonths}} mois",
      unit: "mois",
      tooltip: "Cycle d'étude exprimé en mois",
    },
    lastStudy: {
      label: "Dernière étude",
      tooltip:
        "Date déterminée en fonction de la date de création de la dernière étude pour cet actif.",
    },
    nextStudy: {
      label: "Prochaine étude",
      tooltip:
        "Date déterminée en fonction de la dernière étude ainsi que de la fréquence d'étude.",
    },
    isStudyOverdue: {
      label: "La date de la dernière étude pour cet actif est trop ancienne.",
    },
    planFile: {
      label: "Plan (fichier PDF)",
    },
    plan: {
      label: "Plan",
    },
    validation: {
      serviceDateBeforeManufactureDate:
        "Veuillez entrer une date de service ultérieure à la date de fabrication",
    },
  },
  batchEditSelect: {
    asset: {
      selected_one: "actif sélectionné.",
      selected_other: "actifs sélectionnés.",
    },
    component: {
      selected_one: "composant sélectionné.",
      selected_other: "composants sélectionnés.",
    },
  },
  batchEdit: {
    formError: {
      default: "Une erreur est survenue lors de la mise à jour des actifs.",
      noItemUpdated: "Aucun actif n'a été modifié.",
    },
    state: {
      optionTitle: "État d'actifs",
    },
    assetType: {
      optionTitle: "Type d'actifs",
      label: "Type",
      disabledTooltip:
        "La modification en lot est applicable uniquement pour les actifs ayant le même type.",
      alert:
        'Les informations affichées dans l\'onglet "Techniques" des actifs seront supprimées en modifiant leur type.',
      concernedAssets: "Actifs concernés:",
      all: "Tous",
    },
    conditionRating: {
      optionTitle: "Cote d'état d'actifs",
      label: "Cote d'état",
    },
    replacementCost: {
      optionTitle: "Coût de remplacement d'actifs",
      placeholder: "Entrez un coût",
    },
    location: {
      optionTitle: "Localisation / Secteur",
      disabledTooltip:
        "La modification en lot est applicable uniquement pour les actifs d'une même organisation.",
    },
  },
  batchTransition: {
    description_one: "Veuillez appliquer un nouvel état à l'actif sélectionné.",
    description_other:
      "Veuillez appliquer un nouvel état aux différents actifs sélectionnés.",
    info: "Les actifs remplacés et résiliés ne peuvent pas être modifiés.",
    formSuccess:
      "Tous les actifs '{{initialState}}' ont été modifiés à l'état '{{newState}}'.",
    formErrorGeneric:
      "Une erreur est survenue lors de la modification des actifs '{{initialState}}'.",
    formErrorItems:
      "Les actifs suivants n'ont pas pu être modifiés: {{items}}.",
  },
  risk: {
    label: "Niveau de risque",
    low: "Faible",
    moderate: "Modéré",
    high: "Élevé",
    critical: "Critique",
    none: "Non évalué",
  },
  statistics: {
    conditionRating: {
      title: "Cote d'état",
    },
    riskLevel: {
      title: "Niveau de risque",
    },
    state: {
      title: "État",
    },
    type: {
      title: "Distribution par type d’actif",
    },
  },
};
